// @ts-ignore
import { deserialize } from 'deserialize-json-api';
import { PriceApi } from '../api/price/PriceApi';
import { IBasket } from '@/api/price/PriceApi.i';
import { IResponse } from '@/api/httpClient/HttpClient.i';
import mainStore from '../store/main';

const PRODUCTS_PER_REQUEST = 100;

const computeDiscountPercent = (product: IBasket): string => {
  const price = Number(product.amount.total);
  const priceWithDiscount = Number(product.amount.discountedForAuthorized);

  const reversedPercent = priceWithDiscount / price;
  const percent = (1 - reversedPercent) * 100;

  return percent.toFixed().toString();
};

export class PriceService {
  public async initPriceService(): Promise<void> {
    this.priceApi = new PriceApi();
  }

  private priceApi!: PriceApi;

  async getProductAvailability(productId: string): Promise<any | undefined> {
    try {
      const response = await this.priceApi.getProductAvailability(productId);
      const { data } = deserialize(response.data);
      return data;
    } catch (e) {
      return null;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async getProducts(ids: string[], isRefresh?: boolean): Promise<any | undefined> {
    const finalResult: IBasket[] = [];

    const oldIds = mainStore.store.prices.map((item: IBasket) => item.id);
    const comingIds = ids.filter((item) => item.match(/^[0-9]+$/));

    const newIds = isRefresh ? ids : comingIds.filter((id) => !oldIds.includes(id));

    const pages = Math.ceil(ids.length / PRODUCTS_PER_REQUEST);

    const promises = [];

    for (let i = pages; i > 0; i -= 1) {
      promises.push(
        this.priceApi.getProducts({
          filter: `id=${newIds.join(',')}`,
          pageNumber: i,
          pageSize: PRODUCTS_PER_REQUEST,
        }),
      );
    }

    try {
      const results = await Promise.allSettled(promises);

      results.forEach((item: PromiseSettledResult<IResponse<IBasket[]>>) => {
        if (item.status === 'fulfilled') {
          const { data } = deserialize(item.value.data);

          const result = data.map((product: IBasket): IBasket => ({
            ...product,
            discountPercent: computeDiscountPercent(product),
          }));

          finalResult.push(...result);
        }
      });
    } catch (e) {
      return Promise.resolve([]);
    }

    return Promise.resolve(finalResult);
  }
}

export default new PriceService();
